import { createSlice } from "@reduxjs/toolkit";

let initialState = {};
const serializedState = localStorage.getItem("redux.filtersv2");
if (serializedState !== null) {
  try {
    initialState = JSON.parse(serializedState);
  } catch (err) {}
}

const filtersv2Slice = createSlice({
  name: "filtersv2",
  initialState,
  reducers: {
    set_filter: (state, action) => {
      const newState = { ...state, [action.payload.key]: action.payload.filter };
      localStorage.setItem("redux.filtersv2", JSON.stringify(newState));

      return newState;
    },
  },
});

export default filtersv2Slice.reducer;
